import { BaseModel } from "../base-model";
import { ItemStateModel } from "../base-itemstate";
import {
    ReportEmailLookupInfoDto,
    ReportEmailServerLookupInfoDto,
    ReportMediaLookupInfoDto,
    ReportTemplateLookupInfoDto,
    ReportUserLookupInfoDto,
    // CustomHtmlContent
} from ".";



export interface ILargeMailingPersonInfoModel extends ItemStateModel {
    PersonId: number;
    Lang: number;
    Email: string;
    Name: string;
    FirstName: string;
    LetterTitle: string;
    Ident: string;
    Addresstitle: string;
    Reference: string;
    DemandID: number;
    ValidType: any;
}

export interface ILargeMailingModel extends ItemStateModel {
    /**MailingMethod
     * Omnicomposer =0,
     * HtmlUrl =1
     * HtmlFile=2,
     * zip = 3,
     * PicturelUrl= 4
     */
    MailingMethod: number;
    IsTest: boolean;
    IsDryRun?: boolean;

    Module?: number;
    UserId: number;
    SenderName?: string;
    FromEmail: string;


    ToEmail?: string;
    ToTestingMail?:string;
    TreviPartnerIDs?: number[];

    LangId: number;
    EmailLangId?: number;
    HtmlContent?: string;
    HtmlUrl?: string;
    Subject: string;
    UploadFile?: any;

    
    PersonIds?: number[];
    DemandIds?: number[];
    PersonInfos?: ILargeMailingPersonInfoModel[];
    DemandInfos?: ILargeMailingPersonInfoModel[];

    LookupInfos?: LargeMailingLookupInfosDto;
    UserInfos?: any;

    IsVisibleToSendAll?: boolean;
    UseSpecialMailingTrevi?:boolean;
    TreviFeeMessage?: string;
    IsSelectAll?: boolean;
    PersonCondition?: any;
    DemandCondtion?: any;
}

export class LargeMailingModel extends BaseModel<ILargeMailingModel> implements ILargeMailingModel {
    MailingMethod: number;
    IsTest: boolean;
    IsDryRun?: boolean;

    Module?: number;
    UserId: number;
    SenderName?: string;
    FromEmail: string;

    ToEmail?: string;
    ToTestingMail?:string;
    TreviPartnerIDs?: number[];

    LangId: number;
    EmailLangId?: number;
    HtmlContent?: string;
    HtmlUrl?: string;
    Subject: string;
    UploadFile?: any;

    PersonIds?: number[];
    DemandIds?: number[];
    PersonInfos?: ILargeMailingPersonInfoModel[];
    DemandInfos?: ILargeMailingPersonInfoModel[];
    LookupInfos?: LargeMailingLookupInfosDto;
    UserInfos?: any;

    IsVisibleToSendAll?: boolean;
    UseSpecialMailingTrevi?:boolean;
    TreviFeeMessage?: string;
    
    IsSelectAll?: boolean;
    PersonCondition?: any;
    DemandCondtion?: any;

    constructor(option?: ILargeMailingModel) {
        super(option);
        this.MailingMethod = this.MailingMethod || 0;
        this.IsTest = this.IsTest || true;
        this.IsDryRun = this.IsDryRun || false;

        this.Module = this.Module || 0;
        this.UserId = this.UserId || 0;
        this.SenderName = this.SenderName || "";
        this.FromEmail = this.FromEmail || "";

        this.ToEmail = this.ToEmail || "";
        this.ToTestingMail = this.ToTestingMail || "";
        this.TreviPartnerIDs = this.TreviPartnerIDs || [];

        this.LangId = this.LangId || 0;
        this.EmailLangId = this.EmailLangId || 0;
        this.HtmlContent = this.HtmlContent || "";
        this.HtmlUrl = this.HtmlUrl || "";

        this.Subject = this.Subject || "";
        this.LookupInfos = this.LookupInfos || new LargeMailingLookupInfosDto;
        this.UploadFile = this.UploadFile || null;

        this.PersonIds = this.PersonIds || [];
        this.DemandIds = this.DemandIds || [];
        this.PersonInfos = this.PersonInfos || [];
        this.DemandInfos = this.DemandInfos || [];
        this.UserInfos = this.UserInfos || [];

        this.IsVisibleToSendAll = this.IsVisibleToSendAll || false;
        this.UseSpecialMailingTrevi = this.UseSpecialMailingTrevi || false;
        this.TreviFeeMessage = this.TreviFeeMessage || "";

        this.IsSelectAll = this.IsSelectAll || false;
        this.PersonCondition = this.PersonCondition || null;
        this.DemandCondtion = this.DemandCondtion || null;
    }
}

export class LargeMailingLookupInfosDto {
    Emails: ReportEmailLookupInfoDto[];
    EmailServers: ReportEmailServerLookupInfoDto[];
    Media: ReportMediaLookupInfoDto[];
    // MessageFolders: ReportMessageFolderLookupInfoDto[];
    // Messages: ReportMessageLookupInfoDto[];
    Templates: ReportTemplateLookupInfoDto[];
    Users: ReportUserLookupInfoDto[];
    /**
     *
     */
    constructor() {
        this.Emails = [];
        this.EmailServers = [];
        this.Media = [];
        // this.MessageFolders = [];
        // this.Messages = [];
        this.Templates = [];
        this.Users = [];
    }
}